import { type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';
import { type RootState } from '@editor2/reducers/root';
import { createChangesPayload } from '@editor2/services/unsavedChangesService';
import { showErrorToast } from '@editor2/services/toastService';
import { validateChangesPayload } from '@editor2/services/validateChangesPayloadService';
import { validateYAMLConfig } from '@editor2/services/yamlValidationService';
import { saveResourceChanges } from '@editor2/reducers/editor/effects';
import { modalStyles } from './styles';

import CourseChangesDiff from '../CourseChangesDiff';

interface Props {
	isShown: boolean;
	courseId: number;
	onHide: () => void;
}

const SaveChangesModal: FC<Props> = (props) => {
	const { isShown, courseId, onHide } = props;

	const dispatch = useDispatch();
	const course = useSelector((state: RootState) => state.courses[courseId]);
	const { headCommit } = useSelector((state: RootState) => state.courses[courseId]);

	const changesPayload = createChangesPayload(course);

	const saveChangesSubmit = () => {
		try {
			validateYAMLConfig(course.book.yaml_config);
			validateChangesPayload(changesPayload);

			dispatch(
				saveResourceChanges({ payload: changesPayload, courseId, resourceCommit: headCommit })
			);
			onHide();
		} catch (error) {
			showErrorToast(error.message);
		}
	};

	const title = <div>Save changes</div>;

	const footer = (
		<Button variant="success" size="sm" onClick={saveChangesSubmit}>
			Save
		</Button>
	);

	return (
		<ModalWindow
			isShown={isShown}
			onHide={onHide}
			title={title}
			footer={footer}
			modalStyles={modalStyles}>
			<CourseChangesDiff bookChanges={changesPayload.book} courseId={courseId} />
		</ModalWindow>
	);
};

export default SaveChangesModal;
